import React from 'react'
import './PRAAVISuportTicket.css'
import { Col, Row } from 'antd'
function PRAAVISuportTicket() {
    return (
        <div className='mt-3 ml-2'>
            <Row>
                <Col lg={5}>
                    <div className='ml-5'>
                        <p className='praavi-Unresolved'>+ Create New</p>
                    </div>
                    <div className='praavi-create-back ml-5 mt-4'>
                        <p className='praavi-lorem-title'>Lorem dolores quantum</p>
                        <p className='praavi-hr-lorem-content'>Lorem ipsum dolor, consectetur an adipiscing elit, sed do eiusmod so tempor incididunt the value  consectetur an adipiscing elit </p>
                        <div className='flex justify-between mt-2'>
                            <p className='praavi-hr-date'>27 June</p>
                            <p className='praavi-hr-unresolved'>Unresolved</p>
                        </div>
                    </div>
                    <div className='praavi-create-back ml-5 mt-2'>
                        <p className='praavi-lorem-title'>Lorem dolores quantum</p>
                        <p className='praavi-hr-lorem-content'>Lorem ipsum dolor, consectetur an adipiscing elit, sed do eiusmod so tempor incididunt the value  consectetur an adipiscing elit </p>
                        <div className='flex justify-between mt-2'>
                            <p className='praavi-hr-date'>27 June</p>
                            <p className='praavi-hr-unresolved'>Unresolved</p>
                        </div>
                    </div>
                    <div className='praavi-create-back ml-5 mt-2'>
                        <p className='praavi-lorem-title'>Lorem dolores quantum</p>
                        <p className='praavi-hr-lorem-content'>Lorem ipsum dolor, consectetur an adipiscing elit, sed do eiusmod so tempor incididunt the value  consectetur an adipiscing elit </p>
                        <div className='flex justify-between mt-2'>
                            <p className='praavi-hr-date'>27 June</p>
                            <p className='praavi-hr-unresolved'>Unresolved</p>
                        </div>
                    </div>
                    <div className='praavi-create-back ml-5 mt-2'>
                        <p className='praavi-lorem-title'>Lorem dolores quantum</p>
                        <p className='praavi-hr-lorem-content'>Lorem ipsum dolor, consectetur an adipiscing elit, sed do eiusmod so tempor incididunt the value  consectetur an adipiscing elit </p>
                        <div className='flex justify-between mt-2'>
                            <p className='praavi-hr-date'>27 June</p>
                            <p className='praavi-hr-unresolved'>Unresolved</p>
                        </div>
                    </div>
                    <div className='praavi-create-back ml-5 mt-2'>
                        <p className='praavi-lorem-title'>Lorem dolores quantum</p>
                        <p className='praavi-hr-lorem-content'>Lorem ipsum dolor, consectetur an adipiscing elit, sed do eiusmod so tempor incididunt the value  consectetur an adipiscing elit </p>
                        <div className='flex justify-between mt-2'>
                            <p className='praavi-hr-date'>27 June</p>
                            <p className='praavi-hr-unresolved'>Unresolved</p>
                        </div>
                    </div>
                </Col>
                <Col lg={16}>
                    <div className='ml-5'>
                        <p className='praavi-hr-praavi'>PRAAVI Support</p>
                        <div className='praavi-hr-chat'>
                            <div className='flex justify-between praavi-hr-bo'>
                                <p className='praavi-hr-chat-contant'>Lorem dolores quantum</p>
                                <div className='mr-5'>
                                    <p className='praavi-hr-resolve'>Unsolved</p>
                                    {/* <p className='praavi-hr-mark'>Mark a resolve</p> */}
                                </div>
                            </div>
                            <div className='p-5'>
                                <div className='mt-5'>
                                    <span className='praavi-chat-left'>Lorem ipsum dolor, consectetur an adipiscing elit,sed</span>
                                </div>
                                <div className='mt-10 chat-right'>
                                    <span className='praavi-chat-right1'>Lorem ipsum dolor, consectetur an adipiscing elit,sed</span>
                                </div>
                                <div className='mt-5'>
                                    <span className='praavi-chat-left'>Lorem ipsum dolor, consectetur an adipiscing elit,sed</span>
                                </div>
                                <div className='mt-10 chat-right'>
                                    <span className='praavi-chat-right1'>Lorem ipsum dolor, consectetur an adipiscing elit,sed</span>
                                </div>
                                <div className='mt-5'>
                                    <span className='praavi-chat-left'>Lorem ipsum dolor, consectetur an adipiscing elit,sed</span>
                                </div>
                                <div className='mt-8'>
                                    <span className='praavi-chat-left'>Lorem ipsum dolor, consectetur an adipiscing elit,sed</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default PRAAVISuportTicket